import vsComponent from './vsBreadcrumb';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
